import { SelectField } from '@mi-front/ui';
import { auditSpotAuditSpotMediaList } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';

type Props = {
  stationId: string;
  label: string;
  name: string;
  multiple?: boolean;
  markRequired?: boolean;
};

/**
 * Async select of spot media by customId via api-v2 media list.
 */
export function AudioSelect({ stationId, label, name, multiple = true, markRequired }: Props) {
  const { $t } = useIntl();

  return (
    <SelectField
      label={label}
      name={name}
      placeholder={$t({
        id: 'audit.scheduleStatusScreen.filter.idPlaceholder',
        defaultMessage: 'Todos',
      })}
      options={[] as { customId: string }[]}
      getOptionValue={(m: { customId: string }) => m.customId}
      getOptionLabel={(m: { customId: string }) => m.customId}
      loadOptions={async (customId) => {
        const res = await auditSpotAuditSpotMediaList({
          station: stationId,
          filter: customId ? [`customId||$cont||${customId}`] : undefined,
          fields: ['id', 'duration', 'customId'],
          limit: 50,
        });

        return res.data.map((item) => ({
          id: item.id,
          duration: item.duration,
          customId: item.customId,
        }));
      }}
      multiple={multiple}
      markRequired={markRequired}
    />
  );
}
